export default {
    key: 'first-flyerglider',
    common: {
        productName: 'core.productNames.first-flyerglider',
        splashMessage: 'offerFlow.splashMessage.first-flyerglider',
        headingAside: 'offerFlow.headingAside.first-flyerglider',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.first-flyerglider',
        infoModal: {
            heading: 'offerFlow.pages.stepDate.infoModal.heading.first-flyerglider',
            body: 'offerFlow.pages.stepDate.infoModal.body.first-flyerglider',
        },
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.infoModal.heading.first-flyerglider',
            body: 'offerFlow.pages.stepPassengers.infoModal.body.first-flyerglider',
        },
    },
} satisfies OfferFlowContent;
